import {useEffect, useLayoutEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {MODELS} from "../../../../Apis/Models";
import {TABLES} from "../../../../Apis/Tables";
import {clearSearchFilters} from "../../../../reduxToolkit/Search/SearchSlice";
import {permissionObj} from "../../../../Helpers/permission";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @Job Title: Full Stack Developer
 *
 * @description
 * AccessApp component manages search functionality, user permissions, and UI interactions.
 * It controls pagination, filtering, sorting, and data fetching.
 *
 * @returns {object} Object containing state variables and handler functions.
 */
export const AccessApp = () => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [filterDialogShow, setFilterDialogShow] = useState(false);
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const {t} = useTranslation();
    const [bodyForExport, setBodyForExport] = useState('');
    const [moduleId, setModuleId] = useState(`${MODELS.UserAccessLog}`);
    const [option, setOption] = useState(`${TABLES.USER_ACCESS_LOG}`);
    const [criteria, setCriteria] = useState(null);
    const [search, setSearch] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [searchResults, setSearchResults] = useState('');
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [searchElement, setSearchElement] = useState('');
    const [modified, setModified] = useState(false);
    const [expandImage, setExpandImage] = useState('');

    useEffect(() => {
        return () => {
            dispatch(clearSearchFilters());
        };
    }, [activeStep]);

    useLayoutEffect(() => {
        let steps = [];
        if (DEV || permission?.includes(permissionObj?.WEB_ACCESS_USER_READ)) steps.push(t("users"));
        if (DEV || permission?.includes(permissionObj?.WEB_ACCESS_VEHICLE_READ)) steps.push(t("vehicles"));

        if (permission?.includes(permissionObj?.WEB_ACCESS_USER_READ)) {
            setActiveStep(0);
            changeModuleAndOption(0)
        } else if (permission?.includes(permissionObj?.WEB_ACCESS_VEHICLE_READ)) {
            setActiveStep(1);
            changeModuleAndOption(1)
        }

        setSteps(steps);
    }, [permission,t]);

    const handleStepChange = (step) => {
        changeModuleAndOption(step);
        setFinalArray([]);
        setActiveStep(step);
    };

    const changeModuleAndOption = (step) => {
        if(step === 0){
            setModuleId(`${MODELS.UserAccessLog}`)
            setOption(`${TABLES.USER_ACCESS_LOG}`);
        }else{
            setModuleId(`${MODELS.VehicleAccessLog}`)
            setOption(`${TABLES.VEHICLE_ACCESS_LOG}`);
        }
    };

    return {
        DEV, permission,
        navigate,
        steps,
        setActiveStep,
        handleStepChange,
        activeStep,
        filterDialogShow,
        setFilterDialogShow,
        bodyForExport,
        setBodyForExport,
        moduleId,
        option,
        criteria,
        setCriteria,
        search,
        setSearch,
        finalArray,
        setFinalArray,
        searchResults,
        setSearchResults,
        modified,
        setModified,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        contractorId,
        supplierId,
        expandImage, setExpandImage
    };
};
